import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const SeoSocial = ({
  url, description, title, imageUrl,
}) => {
  // set landing page default here
  const metaUrl = url || 'https://www.bostonglobe.com/metro/crime-courts/graphics/2022/02/hate-we-give';
  const metaDescription = description || 'Hate crimes are hurting everyone as America’s hate culture continues to be an epidemic.';
  const metaTitle = title || 'Hate We Give: FBI report reflects the highest surge of hate crimes in 12 years';
  const metaImage = imageUrl || 'https://bostonglobe-prod.cdn.arcpublishing.com/resizer/Z3PKasDUHtet8d02DmVCQAMZ0Hc=/2048x0/cloudfront-us-east-1.images.arcpublishing.com/bostonglobe/FXJBJILQJ6QC5XUHSQ3CVUDQV4.JPG';

  return (
    <Helmet
      htmlAttributes={{
        lang: 'en-US',
      }}
      title={title}
      titleTemplate="%s - The Boston Globe"
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: metaTitle,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:url',
          content: metaUrl,
        },
        {
          property: 'og:image',
          content: metaImage,
        },
        {
          property: 'og:site_name',
          content: 'BostonGlobe.com',
        },
        {
          property: 'og:type',
          content: 'article',
        },
        {
          property: 'og:city',
          content: 'Boston',
        },
        {
          property: 'og:state',
          content: 'MA',
        },
        {
          property: 'og:country',
          content: 'US',
        },
        {
          property: 'fb:admins',
          content: '100001044693856,507486035',
        },
        {
          property: 'fb:app_id',
          content: '103933749691726',
        },
        {
          property: 'fb:pages',
          content: '5637143257',
        },
        {
          property: 'article:publisher',
          content: 'https://www.facebook.com/globe',
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:site',
          content: '@BostonGlobe',
        },
        {
          name: 'twitter:creator',
          content: '@BostonGlobe',
        },
        {
          name: 'twitter:title',
          content: metaTitle,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
        {
          name: 'twitter:image',
          content: metaImage,
        },
        {
          name: 'twitter:url',
          content: metaUrl,
        },
      ]}
      link={[
        {
          rel: 'icon',
          type: 'image/x-icon',
          href: 'https://www.bostonglobe.com/pf/resources/images/favicon.png?d=312',
        },
        {
          rel: 'apple-touch-icon',
          sizes: '180x180',
          href: 'https://www.bostonglobe.com/pf/resources/images/icons/apple-touch-icon.png?d=312',
        },
        {
          rel: 'icon',
          type: 'image/png',
          sizes: '32x32',
          href: 'https://www.bostonglobe.com/pf/resources/images/icons/favicon-32x32.png?d=312',
        },
        {
          rel: 'icon',
          type: 'image/png',
          sizes: '16x16',
          href: 'https://www.bostonglobe.com/pf/resources/images/icons/favicon-16x16.png?d=312',
        },
        {
          rel: 'mask-icon',
          href: 'https://www.bostonglobe.com/pf/resources/images/icons/safari-pinned-tab.svg?d=312',
          color: '#070707',
        },
      ]}
    />
  );
};

SeoSocial.defaultProps = {
  url: '',
  title: '',
  description: '',
  imageUrl: 'https://www.bostonglobe.com/pf/resources/images/logo-bg.jpg?d=312',
};

SeoSocial.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
};

export default SeoSocial;
